const productData = [
  {
    id: 1,
    name: "Courtline Sweater Knit Dress",
    isBestSeller: true,
    category: "Dresses",
    price: "115.00",
    reviews: "342",
    rating: "4.6",
    image: "/img/101-averlynxstore.png",
    images: [
      "/img/101-averlynxstore.png",
      "/img/101a-averlynxstore.png",
      "/img/101b-averlynxstore.png",
      "/img/101c-averlynxstore.png",
    ],
    size: ["XS", "S", "M", "L"],
    colors: ["White", "Steel Grey"],
    material: "92% Modal, 8% Spandex — ultrasoft brushed fabrication",
    description: [
      "A sleek midi-length knit dress crafted from ultrasoft brushed stretch fabric, designed to move with you from studio to street.",
      "Featuring a flattering ribbed construction that sculpts the waist while allowing full range of motion during practice.",
      "Thumbholes at the sleeves keep layers in place during inversions and transitions, adding a thoughtful functional detail.",
      "The relaxed yet refined silhouette pairs equally well with sneakers for a casual errand run or with boots for an evening out.",
      "The soft-touch fabric is selected for comfortable wear and long-lasting shape retention.",
      "Machine washable for easy care; fabric retains its shape and colour wash after wash.",
    ],
    features: [
      "Ultrasoft brushed fabric with four-way stretch and a second-skin feel",
      "Midi length with a slight A-line flare for effortless movement",
      "Ribbed knit texture sculpts and flatters the figure",
      "Thumbhole cuffs keep sleeves in place during practice",
      "Flatlock stitching eliminates chafe for all-day comfort",
      "Machine wash cold; lay flat to dry",
      "Carefully selected soft-touch materials",
    ],
  },
  {
    id: 2,
    name: "Courtline Sweater Knit Cardigan",
    isBestSeller: true,
    category: "Tops",
    price: "140.00",
    reviews: "289",
    rating: "4.7",
    image: "/img/102-averlynxstore.png",
    images: [
      "/img/102-averlynxstore.png",
      "/img/102a-averlynxstore.png",
      "/img/102b-averlynxstore.png",
      "/img/102c-averlynxstore.png",
      "/img/102d-averlynxstore.png",
    ],
    size: ["XS", "S", "M", "L"],
    colors: ["Black", "Oatmeal Heather"],
    material: "100% Cashmere — lightweight yet exceptionally warm",
    description: [
      "A luxurious open-front cardigan knit from Grade-A Mongolian cashmere, delivering an elevated layer that works as hard as you do.",
      "The fine-gauge knit regulates temperature naturally — warm enough for cool morning studio sessions, breathable enough to wear all day.",
      "Designed with a relaxed drop-shoulder silhouette and ribbed cuffs that feel soft against the skin without irritation.",
      "Side pockets are invisibly integrated into the seam for a clean look while keeping hands warm or storing small essentials.",
      "Available in elevated neutral tones that complement the averlynxstore wardrobe from leggings to joggers.",
      "A permanent wardrobe investment: cashmere softens further with every wash, growing more comfortable over time.",
    ],
    features: [
      "Grade-A Mongolian cashmere, 100% natural fibres",
      "Lightweight construction: warm without bulk",
      "Open-front design for easy on and off",
      "Ribbed cuffs and hem for shape retention",
      "Hidden side pockets for everyday practicality",
      "Fine-gauge knit construction",
      "Hand wash or machine wash on delicate; dry flat",
    ],
  },
  {
    id: 3,
    name: "Haven Crew Neck Pullover",
    isBestSeller: true,
    category: "Sweatshirts & Hoodies",
    price: "128.00",
    reviews: "5547",
    rating: "4.5",
    image: "/img/103-averlynxstore.png",
    images: [
      "/img/103-averlynxstore.png",
      "/img/103a-averlynxstore.png",
      "/img/103b-averlynxstore.png",
      "/img/103c-averlynxstore.png",
      "/img/103d-averlynxstore.png",
    ],
    size: ["XS", "S", "M", "L", "XL"],
    colors: ["Heather Grey", "Ballet Pink"],
    material:
      "80% Organic Cotton, 20% Recycled Polyester — heavyweight French terry",
    fitBlurb:
      "Unisex style. Designed for a boxy, oversized look—size down once if you prefer a closer fit.",
    detailDescription:
      "This best seller combines classic neutral colours with a relaxed dropped-shoulder fit. It has a traditional crewneck, ribbed cuffs and hem, and midweight French terry that is smooth on the outside and softly fleeced within. Pair it with coordinating lounge bottoms for an easy matching set.",
    detailExploreLabel: "EXPLORE HAVEN.",
    fitBullets: [
      "Designed for a boxy, oversized look—size down once if you prefer a closer fit",
      "Unisex style",
    ],
    fabricationBullets: [
      "French terry that's smooth on outside and fleecy on the inside",
      "65% Cotton, 35% Polyester",
      "Machine wash separately on cold, gentle cycle. Tumble dry low, gentle cycle.",
    ],
    modelNote: "Model is 5'9\" wearing S",
    description: [
      "A premium heavyweight crew neck crafted from organic cotton French terry that delivers on both warmth and effortless style.",
      "The generous fit is designed to be worn oversized — perfect over a sports bra post-practice or layered for a casual day off.",
      "Dropped shoulders and a longer hem at the back create a modern, relaxed silhouette that flatters every body type.",
      "Ribbed collar, cuffs and hem are knitted to spec so they hold their shape season after season without stretching out.",
      "A clean back-neck finish adds durability while keeping the exterior deliberately minimal.",
      "A wardrobe cornerstone that transitions seamlessly from morning warm-ups to café runs with zero compromise on style.",
    ],
    features: [
      "Heavyweight 400gsm French terry for warmth without overheating",
      "Relaxed, oversized fit — size down for a more fitted look",
      "Dropped shoulder construction for unrestricted movement",
      "Longer back hem for full coverage",
      "Ribbed collar, cuffs and hem maintain shape",
      "Clean reinforced back-neck detail",
      "Organic-cotton blend fabrication",
      "Machine washable",
    ],
  },
  {
    id: 4,
    name: "Haven Lounge Short",
    category: "Shorts",
    price: "125.00",
    reviews: "178",
    rating: "4.6",
    image: "/img/104-averlynxstore.png",
    images: [
      "/img/104-averlynxstore.png",
      "/img/104a-averlynxstore.png",
      "/img/104b-averlynxstore.png",
      "/img/104c-averlynxstore.png",
      "/img/104d-averlynxstore.png",
    ],
    size: ["XS", "S", "M", "L"],
    colors: ["Black", "Eclipse Blue"],
    material: "87% Nylon, 13% Elastane — high-performance stretch fabric",
    description: [
      "A high-waisted performance short engineered for maximum range of motion during the most demanding workouts.",
      "The compressive four-way stretch fabric smooths and supports while allowing comfortable movement.",
      "A wide waistband sits flat against the skin without digging, staying in place through squats, sprints and inversions alike.",
      "The 4-inch inseam length hits at the mid-thigh for optimal coverage and confidence during dynamic movement.",
      "Hidden back pocket with a waterproof lining stores a key or card securely, keeping your hands free for practice.",
      "Sweat-wicking and quick-dry properties ensure you stay comfortable from warm-up through cool-down and beyond.",
    ],
    features: [
      "High-waisted compression fit for support and smoothing",
      "4-inch inseam for mid-thigh coverage",
      "Wide flat waistband stays put during all movement",
      "Four-way stretch fabric: supportive yet breathable",
      "Hidden zippered back pocket for essentials",
      "Sweat-wicking and quick-dry technology",
      "Flatlock seams prevent chafe",
      "Machine wash cold",
    ],
  },
  {
    id: 5,
    name: "Elevate Support Tank",
    category: "Tops",
    price: "120.00",
    reviews: "305",
    rating: "4.8",
    image: "/img/105-averlynxstore.png",
    images: ["/img/105-averlynxstore.png"],
    size: ["XS", "S", "M", "L"],
    colors: ["White", "Sage"],
    material: "81% Recycled Nylon, 19% Elastane — soft performance jersey",
    description: [
      "A lightweight performance tank engineered from soft recycled stretch jersey, offering moisture management and breathability.",
      "The built-in shelf bra provides medium support without the need for an additional layer, making it ideal for low-to-medium impact activities.",
      "Removable cups allow personalisation of shape and coverage, adapting the fit to your preference and activity level.",
      "The sleek, second-skin silhouette layers seamlessly under hoodies and jackets, or works on its own as a confident studio-ready look.",
      "The fabric uses recycled pre-consumer nylon, helping reduce material waste while maintaining dependable stretch.",
      "Four-way stretch and a chafe-free construction ensure this tank moves with you through yoga flows, Pilates sessions and beyond.",
    ],
    features: [
      "Built-in shelf bra with removable cups for adjustable support",
      "Soft performance jersey: 81% recycled nylon, 19% elastane",
      "Four-way stretch for unrestricted movement",
      "Moisture-wicking and fast-drying",
      "Flatlock stitching throughout eliminates friction",
      "Lightweight and breathable for hot yoga and high heat",
      "Machine wash cold",
    ],
  },
  {
    id: 6,
    name: "Rally Performance Short",
    category: "Shorts",
    price: "95.00",
    reviews: "198",
    rating: "4.4",
    image: "/img/106-averlynxstore.png",
    images: [
      "/img/106-averlynxstore.png",
      "/img/106a-averlynxstore.png",
      "/img/106b-averlynxstore.png",
      "/img/106c-averlynxstore.png",
      "/img/106d-averlynxstore.png",
    ],
    size: ["XS", "S", "M", "L"],
    colors: ["Black", "Raisinette"],
    material: "88% Nylon, 12% Spandex — lightweight woven performance fabric",
    description: [
      "A court-ready tennis short designed with input from professional athletes to deliver peak performance on and off the court.",
      "The woven performance fabric is intentionally lightweight and breathable, keeping you cool during the most intense rallies.",
      "An internal compression brief offers support and coverage without adding bulk, so you stay comfortable from warm-up to match point.",
      "The 5-inch inseam is engineered to stay in place during explosive lateral movement, lunges and serves.",
      "Side pockets are designed to hold tennis balls securely — a functional detail that serious players will appreciate.",
      "The sleek, minimal aesthetic transitions effortlessly from the court to a casual lunch or studio session.",
    ],
    features: [
      "Lightweight woven performance fabric with excellent breathability",
      "Internal compression brief for built-in support",
      "5-inch inseam designed to stay put during lateral movement",
      "Side pockets sized for tennis balls",
      "Sweat-wicking and quick-dry properties",
      "Flatlock seams for a smooth, chafe-free feel",
      "Machine wash cold",
    ],
  },
  {
    id: 7,
    name: "Everyday Flow Short Sleeve",
    category: "Tops",
    price: "135.00",
    reviews: "240",
    rating: "4.7",
    image: "/img/107-averlynxstore.png",
    images: [
      "/img/107-averlynxstore.png",
      "/img/107a-averlynxstore.png",
      "/img/107b-averlynxstore.png",
      "/img/107c-averlynxstore.png",
      "/img/107d-averlynxstore.png",
    ],
    size: ["XS", "S", "M", "L", "XL"],
    colors: ["Washed Black", "Clay"],
    material: "47% Lyocell, 47% Cotton, 6% Spandex — butter-soft jersey",
    description: [
      "A relaxed everyday tee cut from a premium lyocell and cotton jersey blend that feels soft from the first wear.",
      "The loose, flowy silhouette drapes naturally without clinging, making it equally suited to rest days and active mornings.",
      "A slightly dropped shoulder and longer body create a modern, elongated proportion that looks great tucked or left untucked.",
      "The breathable natural fibre blend wicks moisture effectively while the slight spandex content gives enough stretch for easy movement.",
      "The lyocell blend offers breathable comfort and a smooth drape for everyday wear.",
      "A wardrobe essential that earns its place in your rotation: understated, versatile and genuinely comfortable to live in.",
    ],
    features: [
      "Lyocell and cotton blend: breathable and buttery soft",
      "Relaxed, slightly oversized fit",
      "Slightly dropped shoulder and elongated body",
      "Versatile enough for studio, street and everything in between",
      "Moisture-wicking natural fibres",
      "Soft natural-fibre blend",
      "Machine wash cold; tumble dry low",
    ],
  },
  {
    id: 8,
    name: "Balance Bra Tank",
    category: "Tops",
    price: "150.00",
    reviews: "190",
    rating: "4.8",
    image: "/img/108-averlynxstore.png",
    images: [
      "/img/108-averlynxstore.png",
      "/img/108a-averlynxstore.png",
      "/img/108b-averlynxstore.png",
      "/img/108c-averlynxstore.png",
    ],
    size: ["XS", "S", "M", "L"],
    colors: ["White", "Toasted Almond"],
    material: "81% Recycled Nylon, 19% Elastane — sculpting stretch fabric",
    description: [
      "A supportive studio tank built with averlynxstore sculpting stretch fabric, delivering medium-high support with a barely-there feel.",
      "The criss-cross strappy back design is both functional and beautiful — distributing tension evenly while creating a feminine silhouette.",
      "A wide underband sits firm against the ribcage, providing support without the discomfort of underwires or restrictive digging.",
      "Removable cups allow you to customise your shape and level of modesty depending on the activity or your personal preference.",
      "The fitted, body-sculpting silhouette smooths and supports without compressing, making it ideal for yoga, Pilates and barre.",
      "Seamless construction and flatlock stitching mean no visible panty lines and no friction, even through the sweatiest sessions.",
    ],
    features: [
      "Medium-high support, ideal for yoga, Pilates and barre",
      "Criss-cross strappy back for comfort and style",
      "Wide underband for firm, comfortable support",
      "Removable cups for adjustable coverage",
      "Sculpting fabric: four-way stretch and support",
      "Sweat-wicking and quick-drying",
      "Seamless, flatlock construction eliminates chafe",
      "Machine wash cold",
    ],
  },
  {
    id: 9,
    name: "Motion Hooded Long Sleeve",
    category: "Tops",
    price: "145.00",
    reviews: "256",
    rating: "4.7",
    image: "/img/109-averlynxstore.png",
    images: [
      "/img/109-averlynxstore.png",
      "/img/109a-averlynxstore.png",
      "/img/109b-averlynxstore.png",
      "/img/109c-averlynxstore.png",
      "/img/109d-averlynxstore.png",
    ],
    size: ["XS", "S", "M", "L", "XL"],
    colors: ["Black", "Espresso"],
    material:
      "88% Nylon, 12% Spandex — soft-touch performance interlock",
    description: [
      "A warm-up essential reimagined with an attached hood, giving you the coverage and comfort of a hoodie without the bulk.",
      "The lightweight interlock fabric traps warmth during warm-ups and cool-downs while remaining breathable enough to keep on during practice.",
      "Thumbhole cuffs extend coverage over the back of the hands, keeping muscles warm and preventing cold air from entering the sleeve.",
      "The kangaroo front pocket is deep enough to hold a phone, wallet or studio essentials — functional for pre and post-practice routines.",
      "A two-way zipper allows you to adjust ventilation and style from fully zipped to a sporty half-open look.",
      "Designed in a longer body length that provides full coverage and stays tucked during forward folds and deep stretches.",
    ],
    features: [
      "Attached hood for warmth and coverage without bulk",
      "Lightweight performance interlock fabric",
      "Thumbhole cuffs for hand coverage during warm-ups",
      "Deep kangaroo front pocket",
      "Two-way zipper for adjustable ventilation",
      "Longer body length for full coverage",
      "Four-way stretch for unrestricted movement",
      "Machine wash cold",
    ],
  },
  {
    id: 10,
    name: 'Pace 7" Training Short',
    category: "Shorts",
    price: "130.00",
    reviews: "312",
    rating: "4.9",
    image: "/img/1010-averlynxstore.png",
    images: [
      "/img/1010-averlynxstore.png",
      "/img/1010a-averlynxstore.png",
      "/img/1010b-averlynxstore.png",
      "/img/1010c-averlynxstore.png",
      "/img/1010d-averlynxstore.png",
    ],
    size: ["XS", "S", "M", "L"],
    colors: ["Black", "Eclipse Blue"],
    material: "85% Nylon, 15% Spandex — lightweight performance stretch",
    description: [
      "A streamlined 7-inch inseam short engineered for high-intensity training, running and hot yoga where breathability is essential.",
      "The featherlight performance fabric weighs almost nothing, eliminating drag and keeping you fast and unrestricted during every sprint and squat.",
      "A wide high-rise waistband lies completely flat to prevent rolling, pinching or shifting — staying exactly where you put it during burpees and box jumps.",
      "The liner-less design layers cleanly under skirts and dresses, while the four-way stretch ensures zero restriction during dynamic movement.",
      "An internal audio cord port routes your headphone cable cleanly through the waistband so it never gets in the way of your workout.",
      "Reflective front and back accents add visibility for early morning or late evening runs in low light.",
    ],
    features: [
      "7-inch inseam for a balance of coverage and freedom of movement",
      "Featherlight performance fabric: barely-there feel",
      "High-rise wide waistband prevents rolling or shifting",
      "Four-way stretch and quick-dry technology",
      "Liner-less design layers cleanly under outerwear",
      "Internal audio cord routing port",
      "Reflective accents for visibility in low light",
      "Machine wash cold",
    ],
  },
  {
    id: 11,
    name: "Motion Crewneck Short Sleeve",
    category: "Tops",
    price: "120.00",
    reviews: "198",
    rating: "4.6",
    image: "/img/1011-averlynxstore.png",
    images: [
      "/img/1011-averlynxstore.png",
      "/img/1011a-averlynxstore.png",
      "/img/1011b-averlynxstore.png",
      "/img/1011c-averlynxstore.png",
      "/img/1011d-averlynxstore.png",
    ],
    size: ["XS", "S", "M", "L", "XL"],
    colors: ["White", "Toasted Almond"],
    material: "87% Nylon, 13% Elastane — soft-touch performance interlock",
    description: [
      "A clean crew neck tee cut from averlynxstore performance interlock — soft to the touch, structured in silhouette and built to move.",
      "The relaxed-yet-refined fit falls just past the hip, making it perfectly proportioned for studio wear, casual weekends and everything between.",
      "Moisture-wicking properties pull sweat away from the skin to keep you dry and comfortable throughout your practice and day.",
      "The crew neck opening is sized to flatter the collarbone without gaping, and the slight set-in sleeve creates a clean shoulder line.",
      "Flatlock stitching throughout means no raised seams to irritate the skin, even under a heavy backpack or long studio session.",
      "A subtle tonal seam detail at the left hem keeps the look understated for everyday wear.",
    ],
    features: [
      "Soft interlock fabric with a structured performance feel",
      "Relaxed crew neck fit, hip length",
      "Moisture-wicking and quick-drying",
      "Flattering collarbone-grazing neckline",
      "Flatlock stitching for zero chafe",
      "Tonal seam detail at left hem",
      "Four-way stretch for unrestricted movement",
      "Machine wash cold",
    ],
  },
  {
    id: 12,
    name: "Drift Lightweight Track Pullover",
    category: "Sweatshirts & Hoodies",
    price: "115.00",
    reviews: "267",
    rating: "4.5",
    image: "/img/1012-averlynxstore.png",
    images: [
      "/img/1012-averlynxstore.png",
      "/img/1012a-averlynxstore.png",
      "/img/1012b-averlynxstore.png",
      "/img/1012c-averlynxstore.png",
      "/img/1012d-averlynxstore.png",
    ],
    size: ["XS", "S", "M", "L", "XL"],
    colors: ["Toasted Almond", "Steel Grey"],
    material:
      "68% Lyocell, 32% Organic Cotton — lightweight French terry",
    description: [
      "A lightweight track pullover crafted from a lyocell and organic cotton French terry blend — an easy layer for warm-ups and cool mornings.",
      "The fabric's natural origin makes it exceptionally breathable while still providing meaningful warmth without the heaviness of traditional sweatshirt fleece.",
      "A full-zip front allows for effortless temperature regulation — open it up during warm-ups and zip closed during cool-downs or commutes.",
      "The relaxed, slightly boxy silhouette layers comfortably over sports bras and tanks without adding unnecessary bulk.",
      "Two front zip pockets are deep enough for a phone, keys and wallet, keeping your hands warm and essentials secure on the go.",
      "Ribbed cuffs and hem are knitted with added elasticity to hold their shape throughout the life of the garment.",
    ],
    features: [
      "Lightweight French terry: warm without the weight",
      "Full-zip front for adjustable ventilation",
      "Relaxed, slightly boxy fit for easy layering",
      "Two deep zippered front pockets",
      "Ribbed cuffs and hem for shape retention",
      "Lyocell and organic cotton blend",
      "Lightweight soft-touch materials",
      "Machine wash cold; tumble dry low",
    ],
  },
  {
    id: 13,
    name: "Axis Straight Leg Pant",
    category: "Pants",
    price: "125.00",
    reviews: "223",
    rating: "4.6",
    image: "/img/1013-averlynxstore.png",
    images: [
      "/img/1013-averlynxstore.png",
      "/img/1013a-averlynxstore.png",
      "/img/1013b-averlynxstore.png",
      "/img/1013c-averlynxstore.png",
      "/img/1013d-averlynxstore.png",
    ],
    size: ["XS", "S", "M", "L"],
    colors: ["Black", "Eclipse Blue"],
    material: "75% Recycled Nylon, 25% Elastane — sculpting compression fabric",
    description: [
      "A high-rise straight-leg pant engineered with compression-level stretch fabric that smooths and supports without feeling restrictive.",
      "The clean, tailored silhouette is designed to look polished enough for a café lunch, yet functional enough for a yoga class or commute.",
      "A wide waistband sits firm and flat against the midsection, creating a smooth line under fitted tops without rolling or bunching.",
      "The relaxed straight leg is intentionally roomy through the thigh and knee, tapering only slightly to the ankle for a modern, elongated look.",
      "Two deep side pockets and a hidden back zip pocket provide ample secure storage for phones, cards and studio essentials.",
      "The fabric is treated with an antimicrobial finish to keep the pant fresh during back-to-back studio sessions without frequent washing.",
    ],
    features: [
      "High-rise compression fabric: supportive and smoothing",
      "Straight-leg silhouette for a polished, elongated look",
      "Wide flat waistband stays in place without rolling",
      "Two side pockets and one hidden back zip pocket",
      "Antimicrobial finish for extended freshness",
      "Four-way stretch for unrestricted movement",
      "Sweat-wicking and quick-dry",
      "Machine wash cold",
    ],
  },
  {
    id: 14,
    name: "Grounded Practice Mat",
    category: "Accessories",
    price: "130.00",
    reviews: "198",
    rating: "4.7",
    image: "/img/1014-averlynxstore.png",
    images: ["/img/1014-averlynxstore.png", "/img/1014a-averlynxstore.png", "/img/1014b-averlynxstore.png"],
    size: ["One Size"],
    colors: ["Black", "Toasted Almond"],
    material:
      "Thermoplastic Polyurethane (TPU) top layer, closed-cell foam core",
    description: [
      "A 5mm yoga mat designed to provide optimal cushioning for joints without compromising stability and grounding in standing poses.",
      "The high-density closed-cell foam core resists moisture absorption, preventing the growth of bacteria and odour even after heavy use.",
      "A grip-textured TPU top surface delivers reliable traction on both dry and slightly damp skin — ideal for hot yoga and high-sweat practices.",
      "The alignment guide printed subtly onto the mat helps beginning and advanced practitioners maintain correct hand and foot placement.",
      "At 61cm wide and 180cm long, this mat offers generous coverage for all body types and practice styles without feeling cramped.",
      "The mat rolls tightly for easy transport and unrolls flat immediately due to its memory foam properties that resist curling at the edges.",
    ],
    features: [
      "5mm thickness: optimal cushioning without sacrificing stability",
      "Grip-textured TPU surface: reliable dry and wet traction",
      "High-density closed-cell foam resists moisture and bacteria",
      "Printed alignment guide for accurate hand and foot placement",
      "61cm wide × 180cm long: generous sizing for all body types",
      "Straight edge design for stable wall and partner practices",
      "Easy to clean with mild soap and water",
    ],
  },
  {
    id: 15,
    name: "averlynxstore Dawn Court Sneaker",
    category: "Shoes",
    price: "150.00",
    reviews: "312",
    rating: "4.8",
    image: "/img/1015-averlynxstore.png",
    images: [
      "/img/1015-averlynxstore.png",
      "/img/1015a-averlynxstore.png",
      "/img/1015b-averlynxstore.png",
      "/img/1015c-averlynxstore.png",
    ],
    size: ["35", "36", "37", "38", "39", "40", "41", "42"],
    colors: ["White/Blush", "Black/Rose Gold"],
    material:
      "Full-grain leather upper, cushioned memory foam insole, rubber outsole",
    description: [
      "A refined everyday sneaker that blends classic athletic heritage with a contemporary streetwear sensibility, crafted from premium full-grain leather.",
      "The cushioned memory foam insole provides all-day comfort whether you're commuting, exploring the city or finishing a long workout.",
      "A durable rubber outsole with multi-directional flex grooves moves naturally with your foot, reducing fatigue during extended wear.",
      "The padded ankle collar and tongue prevent rubbing and irritation, making this sneaker comfortable enough for all-day, everyday use.",
      "Clean tonal stitching and a minimal exterior mean this shoe pairs effortlessly with anything from joggers to dresses.",
      "Available in two refined colourways that complement the averlynxstore palette, from soft blush to steel grey.",
    ],
    features: [
      "Full-grain leather upper: premium quality and durable",
      "Memory foam insole for all-day cushioning",
      "Flexible rubber outsole with multi-directional grooves",
      "Padded ankle collar and tongue prevent rubbing",
      "Minimal branding: clean tonal stitching throughout",
      "Lace-up closure for a customisable fit",
      "Available in full size range 35–42",
      "Wipe clean with a damp cloth",
    ],
  },
  {
    id: 16,
    name: "averlynxstore Restore Knit Sneaker",
    category: "Shoes",
    price: "120.00",
    reviews: "187",
    rating: "4.7",
    image: "/img/1016-averlynxstore.png",
    images: [
      "/img/1016-averlynxstore.png",
      "/img/1016a-averlynxstore.png",
      "/img/1016b-averlynxstore.png",
      "/img/1016c-averlynxstore.png",
    ],
    size: ["35", "36", "37", "38", "39", "40", "41", "42"],
    colors: ["White", "Black"],
    material:
      "Breathable mesh upper, recycled foam midsole, non-marking rubber outsole",
    description: [
      "A recovery-focused sneaker designed to support your body between intense training days, promoting circulation and reducing post-workout fatigue.",
      "The ultra-cushioned recycled foam midsole delivers exceptional shock absorption, protecting joints during walks, light jogs and extended time on your feet.",
      "A breathable engineered mesh upper keeps feet cool and dry throughout the day, from a morning walk to an evening stretch routine.",
      "The wide toe box allows toes to spread naturally, which is essential for foot health and recovery after constrictive training footwear.",
      "A rocker-style outsole geometry encourages a natural gait cycle, helping to roll smoothly from heel to toe with minimal effort.",
      "The slip-on construction with an elastic collar makes this sneaker effortless to put on and remove — ideal for quick studio-to-street transitions.",
    ],
    features: [
      "Recycled foam midsole for superior shock absorption",
      "Engineered mesh upper: breathable and lightweight",
      "Wide toe box for natural foot positioning and recovery",
      "Rocker-style outsole promotes natural gait cycle",
      "Slip-on construction with elastic collar: easy on and off",
      "Non-marking rubber outsole suitable for indoor and outdoor use",
      "Available in full size range 35–42",
      "Machine washable (remove insoles first)",
    ],
  },
  {
    id: 17,
    name: "averlynxstore Tempo Runner",
    category: "Shoes",
    price: "95.00",
    reviews: "234",
    rating: "4.6",
    image: "/img/1017-averlynxstore.png",
    images: [
      "/img/1017-averlynxstore.png",
      "/img/1017a-averlynxstore.png",
      "/img/1017b-averlynxstore.png",
      "/img/1017c-averlynxstore.png",
    ],
    size: ["35", "36", "37", "38", "39", "40", "41", "42"],
    colors: ["White/Black", "Steel Grey/Navy"],
    material:
      "Technical mesh upper, responsive EVA midsole, durable rubber outsole",
    description: [
      "A lightweight running shoe engineered for daily training, combining responsive cushioning with excellent breathability for longer road sessions.",
      "The technical mesh upper is specifically designed for aerobic activities — its open weave structure maximises airflow to keep feet cool during sustained effort.",
      "A responsive EVA midsole returns energy with every footstrike, helping you maintain pace and feel less fatigue over longer distances.",
      "The durable rubber outsole features a multi-surface tread pattern that grips equally well on wet pavement, light trails and gym floors.",
      "Reflective details on the heel and side panel add visibility for early morning and evening runs, enhancing safety in low-light conditions.",
      "A semi-bootie tongue construction hugs the midfoot securely, preventing debris from entering while maintaining a locked-in fit.",
    ],
    features: [
      "Technical mesh upper for maximum airflow during sustained cardio",
      "Responsive EVA midsole returns energy with each stride",
      "Multi-surface rubber outsole for reliable traction",
      "Semi-bootie tongue for a secure, debris-free fit",
      "Reflective heel and side details for visibility in low light",
      "Weight: approximately 220g per shoe (size 38)",
      "Available in full size range 35–42",
      "Machine washable (remove insoles first)",
    ],
  },
  {
    id: 18,
    name: "averlynxstore Blush Edition Sneaker",
    category: "Shoes",
    price: "110.00",
    reviews: "201",
    rating: "4.6",
    image: "/img/1018-averlynxstore.png",
    images: [
      "/img/1018-averlynxstore.png",
      "/img/1018a-averlynxstore.png",
      "/img/1018b-averlynxstore.png",
      "/img/1018c-averlynxstore.png",
    ],
    size: ["35", "36", "37", "38", "39", "40"],
    colors: ["Blush/White", "Black/Gold"],
    material:
      "Premium suede and canvas upper, cushioned insole, vulcanised rubber sole",
    description: [
      "A lifestyle-focused low-top sneaker that merges athletic comfort with a refined street aesthetic in a blush seasonal edition.",
      "The mixed-material upper — combining premium suede overlays with a breathable canvas body — delivers textural depth and a premium finish.",
      "A cushioned insole provides comfort for all-day wear, whether you're running errands, meeting friends or travelling between studio sessions.",
      "The vulcanised rubber sole is both lightweight and durable, providing reliable grip on city streets, gym floors and studio surfaces.",
      "An elastic side panel replaces traditional laces for an effortless slip-on experience without sacrificing the secure fit of a traditional sneaker.",
      "The seasonal colour palette combines soft blush tones, ivory and restrained gold-tone hardware.",
    ],
    features: [
      "Premium suede and canvas mixed-material upper",
      "Seasonal limited-edition colourway",
      "Elastic side gusset for easy slip-on and secure fit",
      "Cushioned insole for all-day comfort",
      "Vulcanised rubber sole: lightweight and durable",
      "Lace-less design for effortless on and off",
      "Available in size range 35–40",
      "Spot clean with a soft brush and mild detergent",
    ],
  },
  {
    id: 19,
    name: "Unisex Ease Slide",
    category: "Shoes",
    price: "135.00",
    reviews: "276",
    rating: "4.8",
    image: "/img/1019-averlynxstore.png",
    images: [
      "/img/1019-averlynxstore.png",
      "/img/1019a-averlynxstore.png",
      "/img/1019b-averlynxstore.png",
      "/img/1019c-averlynxstore.png",
    ],
    size: ["35", "36", "37", "38", "39", "40", "41", "42", "43"],
    colors: ["Black", "Eclipse Blue"],
    material: "Neoprene and spandex upper, moulded EVA midsole, rubber outsole",
    description: [
      "A gender-neutral post-practice slide designed to slip on the moment you step off your mat, offering immediate comfort and recovery support.",
      "The neoprene and spandex upper wraps the foot in a second-skin-like fit that adapts to your foot shape over time, getting more comfortable with each wear.",
      "A moulded EVA midsole provides essential arch support and cushioning — a crucial feature that distinguishes this slide from fashion-focused alternatives.",
      "The contoured footbed is specifically shaped to support the plantar fascia, reducing heel pain and discomfort after high-impact training.",
      "A durable rubber outsole with a subtle treading pattern provides grip on wet surfaces — essential for pool decks, locker rooms and changing areas.",
      "The minimal, understated design in deep, rich colourways makes this slide versatile enough to wear from studio to street without changing.",
    ],
    features: [
      "Neoprene and spandex upper adapts to foot shape over time",
      "Moulded EVA midsole with arch support",
      "Contoured footbed designed to support the plantar fascia",
      "Reduces foot fatigue and heel pain post-workout",
      "Rubber outsole with grip treading for wet surfaces",
      "Unisex design; available in size range 35–43",
      "Machine washable for easy hygiene maintenance",
    ],
  },
  {
    id: 20,
    name: "Restore Wool Slipper",
    category: "Accessories",
    price: "108.00",
    reviews: "189",
    rating: "4.6",
    image: "/img/1020-averlynxstore.png",
    images: ["/img/1020-averlynxstore.png", "/img/1020a-averlynxstore.png", "/img/1020b-averlynxstore.png"],
    size: ["One Size"],
    colors: ["Black", "Toasted Almond"],
    material: "100% Wool felt upper, memory foam insole, anti-slip rubber sole",
    description: [
      "A premium recovery slipper crafted from dense wool felt that naturally regulates temperature and wicks moisture, keeping feet cosy and dry.",
      "The memory foam insole cushions every step, providing relief for tired feet, sore heels and achy joints after intense training.",
      "A flexible anti-slip rubber sole allows you to wear this slipper safely on any indoor surface — from hardwood floors to tile and carpet.",
      "The easy pull-on design with an elasticised opening makes these slippers effortless to put on and remove, even with cold or tired hands.",
      "Wool is naturally antimicrobial and odour-resistant, meaning these slippers stay fresher for longer without frequent washing.",
      "The sleek, minimal design in timeless neutral tones ensures this recovery slipper looks as good as it feels — equally at home post-shower or curled up on the couch.",
    ],
    features: [
      "Dense wool felt upper: naturally temperature-regulating and moisture-wicking",
      "Memory foam insole for superior cushioning and comfort",
      "Anti-slip rubber sole for safe indoor use on any surface",
      "Elasticised pull-on construction: effortless on and off",
      "Naturally antimicrobial and odour-resistant wool",
      "Minimal, timeless aesthetic",
      "Available in One Size (fits EU 36–42)",
      "Spot clean with a damp cloth; do not machine wash",
    ],
  },
];

export default productData;
